<template>
	<component
		:is="tag"
		class="btn"
		:class="classes"
		v-bind="attrs"
		:href="href || undefined"
		:type="tag === 'button' ? type : undefined"
		:disabled="tag === 'button' ? disabled : undefined"
	>
		{{ buttonLabel }}
		<span v-if="tag === 'button'" class="btn__loader">
			<span class="btn__loader-dots">
				<span class="btn__loader-dot"></span>
				<span class="btn__loader-dot"></span>
				<span class="btn__loader-dot"></span>
			</span>
		</span>
	</component>
</template>

<script setup>
import { computed, useAttrs } from 'vue';

const props = defineProps({
	labelUk: {
		type: String,
		default: '',
	},
	labelRu: {
		type: String,
		default: '',
	},
	variant: {
		type: String,
		default: 'orange',
	},
	height: {
		type: String,
		default: '',
	},
	type: {
		type: String,
		default: 'button',
	},
	href: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	className: {
		type: String,
		default: '',
	},
	locale: {
		type: String,
		default: () => document?.documentElement?.lang || 'uk',
	},
});

const attrs = useAttrs();

const tag = computed(() => (props.href ? 'a' : 'button'));

const classes = computed(() => {
	return [
		`btn--${props.variant}`,
		props.height ? `btn--${props.height}` : '',
		props.className,
	];
});

const buttonLabel = computed(() => {
	const isUk = String(props.locale).toLowerCase().startsWith('uk');

	if (isUk) {
		return props.labelUk || props.labelRu;
	}

	return props.labelRu || props.labelUk;
});
</script>